import styled from 'styled-components';

export const ButtonDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;
  flex: 1 0 0;
`;
